import { getUserData } from "@/auth/getUserData";
import { isMobile } from "@/utils/mobile";
import { isLocalhost } from "@/utils/platforms";
import { getInstance } from "./auth0/index";
import { canNavigate } from "@/libs/acl/routeProtection";

/**
 * Return if user is logged in
 * This is completely up to you and how you want to store the token in your frontend application
 * e.g. If you are using cookies to store the application please update this function
 */
// eslint-disable-next-line arrow-body-style
export const isUserLoggedIn = (to, from, next) => {
    const authService = getInstance();

    authService.$watch("loading", (isLoading) => {
        if (isLoading === false) {
            return guardAction();
        }
    });

    const guardAction = () => {
        if (!canNavigate(to) && authService.isAuthenticated) {
            const userData = getUserData();
            if (!userData.ability?.length) {
                return next({ name: "failed-login" });
            }

            return next({ name: "not-authorized" });
        }

        if (authService.isAuthenticated) {
            return next();
        }

        return authService
            .loginOrRedirect({ redirect_uri: `https://${window.location.host}/authorize` })
            .then((isAuthorized) => {
                if (isAuthorized) {
                    return next();
                }

                return false;
            });
    };

    if (!authService.loading) {
        return guardAction();
    }
};

export const handleMobileRedirect = (to, from, next) => {
    // When coming from "mobile." subdomain with an mobile device, we assume you're coming from the app
    // @hack for local, simulates /mobile as mobile.saysimple.io
    if (!window.location.host.startsWith("mobile.") && !(isLocalhost() && to.name === "mobile")) {
        // Return to normal login flow if it isn't mobile
        return next();
    }

    if (!isMobile()) {
        window.location.replace("https://saysimple.com");
        return;
    }

    if (to.name === "authorize-domain") {
        return next();
    }

    const mobileDomainOverride = localStorage.getItem("mobileDomainOverride");

    if (!mobileDomainOverride) {
        return next({
            name: "authorize-domain",
        });
    }

    return next();
};
